<template>
    <div class="product-result__card">
        <a class="product-result__link" :href="url">
            <div class="product-result__img">
                <img class="sr-product-card__image" v-if="primaryImageUrl" :src="primaryImageUrl + `?wid=60&hei=60`" :alt="name" />
                <div v-if="!primaryImageUrl" class="product-result__finish-coming-soon">Product Finish Image Coming Soon</div>
            </div>
            <div class="product-result__body">
                <div class="product-result__stock-number"><span v-html="stockOrProducts"></span></div>
                <div v-if="displayName" class="product-result__display-name"><span v-html="displayName"></span></div>
                <div v-if="additionalDisplayName" class="product-result__additional-display-name"><span v-html="additionalDisplayName"></span></div>
            </div>
        </a>
    </div>
</template>

<script lang="ts">
export default {
    name: 'ProductsSearchCard',
    props: {
        url: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        primaryImageUrl: {
            type: String,
            default: '',
        },
        stockNumber: {
            type: String,
            default: '',
        },
        displayName: {
            type: String,
            default: '',
        },
        additionalDisplayName: {
            type: String,
            default: '',
        },
        translations: {
            type: Object,
            default: {},
        },
    },
    computed: {
        stockOrProducts() {
            return this.stockNumber ? this.stockNumber : this.translations?.Products;
        },
    },
};
</script>
